module.exports = __webpack_public_path__ + "static/img/公众号二维码@2x.be9384f.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/asideMenu/公众号二维码@2x.png
// module id = 08sn
// module chunks = 87